export default "__VITE_ASSET__DF5jMDLa__"